import React from "react";
import { RISK_SPOTLIGHT_CONTENT } from "../../constants";
import "./home.css";

import MapComponent from "../MapComponent";

const RiskSpotlightComponent = ({ ref,details }) => {
  return (
    <div  className="home-page-spotlight">
      <div className="home-page-spotlight-header cl-blue">
        <div className="home-page-spotlight-heading">
          Risk Spotlight
        </div>

        <div className="home-page-spotlight-content">
          {RISK_SPOTLIGHT_CONTENT}
        </div>
      </div>

      <div
        className="home-map-container"
        aria-label="Contains map of suspicious companies"
      >
        <MapComponent
          suspiciousCompanies={details.data?.suspicious_companies}
        />
      </div>
    </div>
  );
};

export default RiskSpotlightComponent;
